import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { RadioButtonLevel } from '../tarifications.component';
import { MatFormField } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';
import { ExpandableRadioButtonComponent } from '../expandable-radio-button/expandable-radio-button.component';
import { LanguageStore } from '../../../shared/services/language.store';
import { ACS_WARRANTY_TABLE_LINK_EN, ACS_WARRANTY_TABLE_LINK_FR } from '../../../shared/helpers/constants';

@Component({
  selector: 'acs-maternity-option-section',
  imports: [
    MatFormField,
    MatSelect,
    MatOption,
    MatRadioGroup,
    MatRadioButton,
    TranslatePipe,
    ReactiveFormsModule,
    ExpandableRadioButtonComponent
  ],
  templateUrl: './maternity-option-section.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaternityOptionSectionComponent {
  @Input({ required: true }) fc!: FormControl;
  @Input({ required: true }) beneficiariesFC!: FormControl;
  @Input({ required: true }) options!: RadioButtonLevel[];
  @Input({ required: true }) sectionDisabled!: boolean;
  @Input({ required: true }) optionsPopulate!: { value: {}; label: string }[];

  #languageStore = inject(LanguageStore);
  get guaranteesTableLink() { return this.#languageStore.currentLanguageCode() === 'fr' ? ACS_WARRANTY_TABLE_LINK_FR : ACS_WARRANTY_TABLE_LINK_EN; }

  expandedOption: number | null = null;

  expandPanel(optionNb: number) {
    this.expandedOption = this.expandedOption === optionNb ? null : optionNb;
  }
}
